module.exports = __webpack_public_path__ + "img/Iconhoverhome.bd5b12bb.svg";